/**
 * Máscara padrão de telefone (blocos #47 e #48): "(11) 99999-9999" para celular
 * e "(11) 3333-4444" para fixo, com DDD. Número com "+" (fora do Brasil) fica
 * como digitado, só com dígitos, espaços e hífens.
 *
 * Mesma regra de apps/api/src/common/utils/phone.util.ts.
 */
export function maskPhone(value: string): string {
  const raw = value ?? '';
  if (raw.trimStart().startsWith('+')) return '+' + raw.replace(/[^\d\s-]/g, '').trimStart();

  const d = raw.replace(/\D/g, '').slice(0, 11);
  if (!d) return '';
  if (d.length <= 2) return `(${d}`;
  const ddd = d.slice(0, 2);
  const rest = d.slice(2);
  if (d.length <= 6) return `(${ddd}) ${rest}`;
  // Até 10 dígitos é fixo (4+4); com 11, celular (5+4).
  const split = d.length === 11 ? 5 : 4;
  return `(${ddd}) ${rest.slice(0, split)}-${rest.slice(split)}`;
}
